import React, { useMemo } from 'react';
import StatsPage from '../StatsPage';
import PrimarySectionRow from '../../../shared/components/primary-section/PrimarySectionRow';
import StatsElement from '../../../shared/entities/stats-element/components/StatsElement';
import { StatsElementType } from '../../../shared/entities/stats-element/enums/StatsElementType';
import { pricingsStatsElementOptions } from './constants/pricingsStatsElementOptions';
import { ViewFilterName } from '../../../shared/entities/filters/enum/types/ViewFilterName';
import { StatsGlobalFilter } from '../types/StatsGlobalFilter';
import { StatsFilterName } from '../enum/StatsFilterName';

const StatsPricings: React.FC = () => {
  const filtersNames = useMemo(
    () => [ViewFilterName.Headquarter, StatsFilterName.IncludeSPACs],
    [],
  ) as StatsGlobalFilter[];

  return (
    <StatsPage header="Pricing Activity" filtersNames={filtersNames}>
      <PrimarySectionRow>
        <StatsElement type={StatsElementType.Pricing} options={pricingsStatsElementOptions} />
      </PrimarySectionRow>
    </StatsPage>
  );
};

export default StatsPricings;
